import Tel1Summary from "./summary";
function Tel1Program({ summaryData = [] }) {
  return (
    <>
      <div className="d-flex mb-3">
        <div className="flex-1 d-flex flex-column">
          <div>Program Training/Pelatihan</div>
          <Tel1Summary summaryData={summaryData} />
        </div>
      </div>
    </>
  );
}

export default Tel1Program;
